import { render, staticRenderFns } from "./DetailPC.vue?vue&type=template&id=6a8d73e6&scoped=true&"
import script from "./DetailPC.vue?vue&type=script&lang=js&"
export * from "./DetailPC.vue?vue&type=script&lang=js&"
import style0 from "./DetailPC.vue?vue&type=style&index=0&id=6a8d73e6&prod&lang=scss&"
import style1 from "./DetailPC.vue?vue&type=style&index=1&id=6a8d73e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8d73e6",
  null
  
)

export default component.exports